/**
 * クラス名：クラウド用PMXファイル読み込むの親部品情報タブ
 * 説明：クラウドにあるPMXファイルを読み込んで子部品情報やファイル情報を表示・複数ファイル選択操作を行うJSである。
 * 作成者：ナンス
 * 作成日：2023/07/24
 * バージョン：1.0
 */
import { Button, Row, Input, Col, Image, Table, DatePicker, Tree, Space, Spin, Checkbox, Select } from 'antd';
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import dayjs from 'dayjs';

import '../../assets/styles/common.css';
import filter_clear_icon from '../../assets/images/filter_clear_icon.png';
import { formatPMXDate } from './Common';
import { commonModal } from './CommonModal';
import { GetParametersByCompId, getCardDetailImg, getCardInfo } from './CommonAPI';
import { dataTypeList } from './Constant';

const PMX_CloudFileDialog_Tab_Parent = React.forwardRef((props, ref) => {
  const [cloudPMXFileLst, setCloudPMXFileLst] = useState([]);
  const [cloudPMXFileLstBK, setCloudPMXFileLstBK] = useState([]);
  const [cloudPMXIQ3FileLst, setCloudPMXIQ3FileLst] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [selectedData, setSelectedData] = useState([]);
  const [selectedDatas, setSelectedDatas] = useState([]);
  const [iq3SelectedRowKeys, setIQ3SelectedRowKeys] = useState([]);

  const [searchFileNm, setSearchFileNm] = useState('');
  const [searchUpdatedStart, setSearchUpdatedStart] = useState('');
  const [searchUpdatedEnd, setSearchUpdatedEnd] = useState('');
  const [searchCustomer, setSearchCustomer] = useState('');
  const [searchDrawingNo, setSearchDrawingNo] = useState('');
  const [searchModifier, setSearchModifier] = useState('');
  const [isImageMaxDisplay, setIsImageMaxDisplay] = useState(false);

  const [isPMXCloudFileDialogOpen, setIsPMXCloudFileDialogOpen] = useState(props.pmxModal);

  const [page, setPage] = useState(1);

  // IQX_WEBEST-246
  const [dataType, setDataType] = useState(3); // デフォルト値をAllに設定
  const [pageSize, setPageSize] = useState(100);
  const pageSizes = ['100', '200', '300', '500'];
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalCountBK, setTotalCountBK] = useState(0);

  useEffect(() => {
    setIsPMXCloudFileDialogOpen(props.pmxModal);
    if (props.cardData) {
      //親部品
      setSearchFileNm('');
      setSearchUpdatedStart('');
      setSearchUpdatedEnd('');
      setCloudPMXFileLst(props.cardData);
      setCloudPMXFileLstBK(props.cardData);
      setSelectedData(props.cardData[0]);
      setSelectedRow(props.cardData[0]?.id);
      // IQX_WEBEST-155
      getPmMXImg(props.cardData[0]?.details);
      setSearchCustomer('');
      setSearchDrawingNo('');
      setSearchModifier('');
      setTotalCount(props?.cardDataTotalCount);
      setTotalCountBK(props?.cardDataTotalCount);
      // setSelectedRowKeys([1]);
    }
  }, [props.cardData]);

  useEffect(() => {
    getDataByFilter(); // 絞り込む検索
  }, [searchFileNm, searchUpdatedStart, searchUpdatedEnd, searchCustomer, searchDrawingNo, searchModifier, dataType]);

  const getPmMXImg = async (details) => {
    for (let i = 0; i < details?.length; i++) {
      if (details[i]?.thumbPath !== undefined) {
        let iq3PmxImg = await getCardDetailImg(details[i]?.id);
        if (iq3PmxImg !== undefined) {
          details[i].thumbPath = URL.createObjectURL(iq3PmxImg);
        } else {
          details[i].thumbPath = '';
        }
      }
    }
    setCloudPMXIQ3FileLst(details);
  };

  let checkedRow = [];

  const onRowCheckboxSelect = (checked, record) => {
    const checkedRow = [...checked];
    setSelectedRowKeys(checkedRow);
    // const selectedRow = record.slice(-1);
    // setSelectedData(selectedRow[0]);
    // // setCloudPMXIQ3FileLst(selectedRow[0]?.parents[0].children);
    // const data = [...selectedDatas];
    // data.push(record);
    // setSelectedDatas(data);
    // props.selectedParentRows(data);
  };

  const onRowSelect = async (record) => {
    setSelectedRow(record.id);
    setSelectedData(record);
    // IQX_WEBEST-155
    for (let i = 0; i < record?.details?.length; i++) {
      if (record?.details[i]?.thumbPath !== undefined) {
        let iq3PmxImg = await getCardDetailImg(record?.details[i]?.id);
        if (iq3PmxImg !== undefined) {
          record.details[i].thumbPath = URL.createObjectURL(iq3PmxImg);
        } else {
          record.details[i].thumbPath = '';
        }
      }
    }
    setCloudPMXIQ3FileLst(record?.details);
  };

  const rowSelection = {
    // selectedRowKeys,
    onChange: onRowCheckboxSelect,
  };

  // ファイル名で絞り込む
  const getFileNmByFilter = (value) => {
    searchFileNm === value ? getDataByFilter() : setSearchFileNm(value);
  };

  // 取引先で絞り込む
  const getCustomerByFilter = (value) => {
    searchCustomer === value ? getDataByFilter() : setSearchCustomer(value);
  };

  // 親図番で絞り込む
  const getDrawingNoByFilter = (value) => {
    searchDrawingNo === value ? getDataByFilter() : setSearchDrawingNo(value);
  };

  // 担当者で絞り込む
  const getModifierByFilter = (value) => {
    searchModifier === value ? getDataByFilter() : setSearchModifier(value);
  };

  // 日付で絞り込む
  const getDateByFilter = (name, dateString) => {
    if (name == 0) {
      searchUpdatedStart === dateString ? getDataByFilter() : setSearchUpdatedStart(dateString);
    } else {
      searchUpdatedEnd === dateString ? getDataByFilter() : setSearchUpdatedEnd(dateString);
    }
  };

  // データタイプで絞り込む
  const getDateTypeByFilter = (value) => {
    dataType === value ? getDataByFilter() : setDataType(value);
  };

  // 絞り込む
  const getDataByFilter = async () => {
    // DBから検索
    setLoading(true); // Waitingダイアログを表示にする
    // IQX_WEBEST-246
    let pageBefore = page - 1;
    let startPage = pageBefore < 0 ? 0 : pageSize * pageBefore;
    let cardData = await getCardInfo(
      pageSize,
      startPage,
      searchCustomer,
      searchFileNm,
      searchDrawingNo,
      searchModifier,
      searchUpdatedStart,
      searchUpdatedEnd,
      dataType
    );
    if (cardData) {
      const cardDatas = cardData ? cardData?.data : [];
      const updatedData = cardDatas?.map((item) => ({
        ...item,
        modified: formatPMXDate(item.modified),
      }));
      setCloudPMXFileLst(updatedData);
      const cardDataTotalCount = cardData?.totalCount ? cardData?.totalCount : 0;
      setTotalCount(cardDataTotalCount);
    }
    setLoading(false); // Waitingダイアログを表示にする
    setPage(1);
  };

  const clearAllFilter = (e) => {
    setSearchFileNm('');
    setSearchUpdatedStart('');
    setSearchUpdatedEnd('');
    setSearchCustomer('');
    setSearchDrawingNo('');
    setSearchModifier('');
    setDataType(3);
    setCloudPMXFileLst(cloudPMXFileLstBK);
    setTotalCount(totalCountBK);
    // setCloudPMXIQ3FileLst(cloudPMXFileLstBK?.length > 0 ? cloudPMXFileLstBK[0].parents[0].children : []);
  };

  useImperativeHandle(
    ref,
    () => ({
      getSelectedParent: () => {
        return selectedData;
      },
      getPMXEstimateInfo: getPMXEstimateInfo,
    }),
    [selectedData]
  );

  const cloudFileParentColumns = [
    {
      id: '1',
      title: '取引先',
      dataIndex: 'customer',
      width: 150 + 'px',
    },
    {
      id: '2',
      title: '名称',
      dataIndex: 'name',
      width: 150 + 'px',
    },
    {
      id: '3',
      title: '親図番',
      dataIndex: 'drawingNo',
      width: 100 + 'px',
    },
    {
      id: '4',
      title: '担当者',
      dataIndex: 'modifier',
      width: 100 + 'px',
    },
    {
      id: '2',
      title: '更新日時',
      dataIndex: 'modified',
      width: 100 + 'px',
    },
  ];
  const cloudFileParentDetailColumns = [
    {
      id: '1',
      title: 'サムネイル',
      dataIndex: 'thumbPath',
      width: 150 + 'px',
      render: (value) => <Image src={value} width={150} preview={isImageMaxDisplay} />,
    },
    {
      id: '2',
      title: '種別',
      dataIndex: 'type',
      width: 100 + 'px',
    },
    {
      id: '3',
      title: '図番',
      dataIndex: 'drawingNo',
      width: 150 + 'px',
    },
    {
      id: '4',
      title: '材質',
      dataIndex: 'material',
      width: 150 + 'px',
    },
    {
      id: '5',
      title: '板厚',
      dataIndex: 'thickness',
      width: 80 + 'px',
    },
    {
      id: '6',
      title: '員数',
      dataIndex: 'quantity',
      width: 60 + 'px',
    },
  ];

  const closePMXModal = () => {
    setIsPMXCloudFileDialogOpen(false);
  };
  const childModalTitle = (
    <div
      style={{
        width: 1800,
        // backgroundColor: '#005fab',
        // // marginLeft: 0,
        // height: 36,
        // marginTop: -20,
        // borderTopLeftRadius: 7,
        // borderTopRightRadius: 7,
        // fontSize: 14,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>PMX取り込み</p>
    </div>
  );
  const addData = () => {};

  const getPMXData = async () => {
    if (selectedData?.details?.length > 0) {
      props?.loading(true); // Waitingダイアログを表示にする
      setIsPMXCloudFileDialogOpen(false);
      props.pmxProcessPattern(true, selectedData);
    } else {
      alert('板金データありません！');
    }
  };

  const setCurrentPage = (value) => {
    setPage(value);
  };

  const handlePageSizeChange = (current, pagesize) => {
    setPageSize(pagesize);
  };

  const getPMXEstimateInfo = async () => {
    // 見積データ作成
    let newParameters = await GetParametersByCompId();
    selectedData?.details?.sort((a, b) => a.id - b.id); // IDで昇順ソート
    let newEstimateInfo = props?.getNewEstimateInfo(newParameters, selectedData?.details?.length);
    return newEstimateInfo;
  };

  const addPMXCloudFileContent = (
    <>
      <Spin
        // spinning={cloudPMXFileLst.length === 0 && cloudPMXFileLstBK.length === 0 ? true : false}
        spinning={loading}
        tip="Loading..."
        size="large"
      >
        <Row>
          {/* IQX_WEBEST-155 */}
          <Col span={20}>
            <Space size="small">
              <Input
                id="customerNm"
                placeholder="取引先"
                className={'input-editable'}
                value={searchCustomer}
                allowClear
                onChange={(e) => setSearchCustomer(e.target.value)}
                onPressEnter={(e) => getCustomerByFilter(e.target.value)}
              />
              <Input
                id="fileNm"
                placeholder="名称"
                className={'input-editable'}
                value={searchFileNm}
                allowClear
                onChange={(e) => setSearchFileNm(e.target.value)}
                onPressEnter={(e) => getFileNmByFilter(e.target.value)}
              />
              <Input
                id="drawingNo"
                placeholder="親図番"
                className={'input-editable'}
                value={searchDrawingNo}
                allowClear
                onChange={(e) => setSearchDrawingNo(e.target.value)}
                onPressEnter={(e) => getDrawingNoByFilter(e.target.value)}
              />
              <Input
                id="modifier"
                placeholder="担当者"
                className={'input-editable'}
                value={searchModifier}
                allowClear
                onChange={(e) => setSearchModifier(e.target.value)}
                onPressEnter={(e) => getModifierByFilter(e.target.value)}
              />

              <DatePicker
                placeholder="更新日時"
                style={{ padding: 5, width: 183 }}
                className={'input-editable'}
                onChange={(name, dateString) => getDateByFilter(0, dateString)}
                value={searchUpdatedStart != '' ? dayjs(searchUpdatedStart, 'YYYY-MM-DD') : ''}
              />
              <label style={{ paddingTop: 3 }}>～</label>
              <DatePicker
                placeholder="更新日時"
                style={{ padding: 5, width: 183 }}
                className={'input-editable'}
                onChange={(name, dateString) => getDateByFilter(1, dateString)}
                value={searchUpdatedEnd != '' ? dayjs(searchUpdatedEnd, 'YYYY-MM-DD') : ''}
              />
              <Select
                placeholder="All"
                style={{ fontSize: '13.5px', width: 90 }}
                id="dataType"
                name="dataType"
                value={dataType}
                onChange={(e) => {
                  getDateTypeByFilter(e);
                }}
              >
                {dataTypeList?.map((option, index) => (
                  <Select.Option key={index} value={option.value}>
                    {option.name}
                  </Select.Option>
                ))}
              </Select>
            </Space>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            <Button style={{ marginLeft: 0 }} className="filterClearButton" onClick={(e) => clearAllFilter()}>
              <div style={{ display: 'flex' }}>
                <Image preview={false} width={18} height={18} src={filter_clear_icon} style={{ marginBottom: '5px' }} />
                <label style={{ marginLeft: '5px', marginTop: 1, fontSize: '12px' }}>検索条件をクリア</label>
              </div>
            </Button>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col span={12}>
            <Table
              id="parentCloudFileTbl"
              showSorterTooltip={false}
              rowClassName={(record) => (record.id == selectedRow ? 'active-row' : 'data-row')}
              columns={cloudFileParentColumns}
              rowKey={(record) => record.id}
              dataSource={cloudPMXFileLst}
              className="parent-cloud-file-tb"
              onRow={(record, index) => {
                return {
                  onClick: (event) => {
                    onRowSelect(record);
                  },
                };
              }}
              pagination={{
                position: ['bottomLeft'],
                total: totalCount,
                showTotal: (total, range) => `全${total}件中${range[0]}件〜${range[1]}件を表示`,
                pageSize: pageSize,
                pageSizeOptions: pageSizes,
                showSizeChanger: true,
                onShowSizeChange: handlePageSizeChange,
                defaultCurrent: 1,
                current: page,
                onChange: async (page, pageSize) => {
                  setCurrentPage(page);
                  setLoading(true); // Waitingダイアログを表示にする
                  // IQX_WEBEST-246
                  let pageBefore = page - 1;
                  let cardData = await getCardInfo(
                    pageSize,
                    pageBefore,
                    searchCustomer,
                    searchFileNm,
                    searchDrawingNo,
                    searchModifier,
                    searchUpdatedStart,
                    searchUpdatedEnd,
                    dataType
                  );
                  if (cardData) {
                    const cardDatas = cardData ? cardData?.data : [];
                    const updatedData = cardDatas?.map((item) => ({
                      ...item,
                      modified: formatPMXDate(item.modified),
                    }));
                    setCloudPMXFileLst(updatedData);
                  }
                  setLoading(false); // Waitingダイアログを表示にする
                },
              }}
              scroll={{ y: 'calc(100vh-220px)', x: '950' }}
            />
          </Col>
          <Col span={12}>
            <Table
              id="parentCloudFileTbl"
              showSorterTooltip={false}
              columns={cloudFileParentDetailColumns}
              dataSource={cloudPMXIQ3FileLst}
              className="parent-cloud-file-iq3-tb"
              pagination={false}
              scroll={{ y: 'calc(100vh-220px)' }}
            />
            <Checkbox
              checked={isImageMaxDisplay}
              onChange={(e) => {
                setIsImageMaxDisplay(e.target.checked);
              }}
            >
              <label style={{ fontWeight: 600 }}>サムネイル拡大表示</label>
            </Checkbox>
          </Col>
        </Row>
        <Row justify="end" style={{ marginTop: cloudPMXFileLst.length > 0 ? -30 : 10 }}>
          <Space>
            <Button className="mainButton" onClick={getPMXData}>
              OK
            </Button>
            <Button className="cancelButton" onClick={closePMXModal}>
              キャンセル
            </Button>
          </Space>
        </Row>
      </Spin>
    </>
  );

  return (
    <>
      {isPMXCloudFileDialogOpen
        ? commonModal(
            isPMXCloudFileDialogOpen,
            childModalTitle,
            null,
            null,
            1800,
            addData,
            closePMXModal,
            addPMXCloudFileContent,
            null,
            // { left: 180, top: 50 },
            false
          )
        : ''}
    </>
  );
});

export default PMX_CloudFileDialog_Tab_Parent;
